import { CHAT_ENDPOINTS, CHAT_SERVER } from '../servers';
import { postRequest } from '../commService';

const useFixtures = process.env.USE_FIXTURES;
const fixtureSessionId = '2_MX40NjIwMTk4Mn5-MTU0NzEyOTA2NDMzOH5PVnNMUTdzVDhRQjVLdEdvQXdoUjlqMzJ-fg';

class ChatServiceV2 {
  constructor() {
    this.chatId = null;
    this.sessionId = null;
  }

  initiateChatV2 = async (inviteIds) => {
    try {
      if (useFixtures) {
        this.sessionId = fixtureSessionId;
      } else {
        const response = await postRequest(
          CHAT_SERVER,
          CHAT_ENDPOINTS.INITIATE_CHAT_V2,
          { inviteIds },
        );
        this.chatId = response.body.chatId;
      }
      return this.chatId;
    } catch (error) {
      this.handleError(error);
      return null;
    }
  };

  getChatInfoV2 = async (chatId) => {
    try {
      const response = await postRequest(
        CHAT_SERVER,
        CHAT_ENDPOINTS.GET_CHAT_INFO_V2,
        { chatId },
      );

      this.chatId = chatId;
      return response.body;
    } catch (error) {
      return { error };
    }
  };

  endChatV2 = async (chatId) => {
    try {
      await postRequest(CHAT_SERVER, CHAT_ENDPOINTS.END_CHAT_V2, {
        chatId,
      });
    } catch (error) {
      this.handleError(error);
    }
  };

  emergencyEndChatV2 = () => {
    postRequest(CHAT_SERVER, CHAT_ENDPOINTS.END_CHAT_V2, { chatId: this.chatId });
  };

  handleError = (error) => {
    if (error) {
      throw new Error(error);
    }
  };
}

const instance = new ChatServiceV2();

export default instance;
